import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const location = useLocation();
  const hasScrolled = useRef(false);
  
  useEffect(() => {
    if (window.self !== window.top) return;
    
    if (!hasScrolled.current) {
      hasScrolled.current = true;
      window.scrollTo(0, 0);
      return;
    }
    
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default ScrollToHash;
